import React from "react"
import PropTypes from "prop-types"

const Spinner = ({
  height,
  width,
  color,
  strokeWidth,
  className,
  circleClassName,
  testId
}) => (
  <span className={className} data-testid={testId}>
    <svg
      height={height}
      width={width}
      viewBox="0 0 200 200"
      className="animate-spin"
    >
      <circle
        cx="100"
        cy="100"
        r="80"
        fill="none"
        stroke={color}
        strokeWidth={`${strokeWidth}px`}
        strokeDasharray="200px"
        strokeDashoffset="2000"
        className={circleClassName}
      />
    </svg>

    <span className="sr-only" role="alert" aria-busy="true">
      Loading...
    </span>
  </span>
)
Spinner.defaultProps = {
  height: 100,
  width: 100,
  color: `black`,
  strokeWidth: 5,
  className: `inline-block`,
  circleClassName: ``,
  testId: `spinner`
}

Spinner.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  circleClassName: PropTypes.string,
  testId: PropTypes.string
}

export default Spinner
